module.exports = __webpack_public_path__ + "fonts/icons.745e0aa.ttf";